export default __webpack_public_path__ + "static/media/la-energia-solar.cc011e4b.jpg";